import { render } from "./OrderSuccessfullyCreated.vue?vue&type=template&id=68003fb7&scoped=true&ts=true"
import script from "./OrderSuccessfullyCreated.vue?vue&type=script&lang=ts"
export * from "./OrderSuccessfullyCreated.vue?vue&type=script&lang=ts"

import "./OrderSuccessfullyCreated.vue?vue&type=style&index=0&id=68003fb7&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68003fb7"]])

export default __exports__